/* eslint-disable camelcase */
/* eslint-disable no-undef */
/* eslint-disable no-return-assign */
/* eslint-disable react/prop-types */
/* eslint-disable react/button-has-type */
import React, {
    useCallback, useEffect, useMemo, useRef, useState, useContext,
} from 'react';
import {
    gql, useFragment, useQuery, useReactiveVar,
} from '@apollo/client';
import cn from 'classnames';
import { selectedPeriodVar } from 'app/apollo/reaction';

import Rub from 'app/components/ui/Rub';
import stubSrc from 'app/components/DishImage/stub-image/stub-m.jpg';
import { NY_DISHES } from 'app/utils/filters';

import { dishes as romanticDishes } from 'global/const/romantic';

import { analyticService } from 'global/services';
import { useDishCustoms } from 'app/views/Hooks/useDishCustoms';
import { CustomIngredientsSelectDishRow } from 'app/views/Menu/Menu/components/CustomIngredientsSelectDishRow';
import { isDesktop } from 'app/utils/resolution';
import { isIOS } from 'app/utils/browser';
import { tp } from 'app/utils/typograf';
import { PathSegmentContext } from 'app/views/Main/PathSegment.context';
import { DishesSelectionContext } from 'app/containers/contexts/dishesSelection.context';
import { URLUpdater } from 'global/utils';
import { CROSSED_PRICE_DISCOUNT_TYPE } from 'app/const/crossedPricesPromo';
import { isDateInRange } from 'app/containers/contexts/filters.context/filters.context';
import { CATEGORY_MAIN } from 'app/const/categories';

import deleteIcon from '../../img/delete-btn.img.svg';
import { BasketPortionSelect } from '../../../CommonComponents';
import {
    NEW_DISH_CARD_FRAGMENT, NEW_DISH_CARD_IMG, RECCURENT_CART_DATA,
    FETCH_JSON_CUSTOMIZATION_COMMENT,
} from '../../graphql/basketWithCustomization.graphql';

import '../../index.scss';

/**
 * @description карточка блюда в корзине. Общая для основного списка и списка
 * блюд, добавленных с баннера в другой цикл.
 *
 * @note cartItem в кэше один на блюдо (cartItem:<dish_id>), поэтому корзина
 * чужого периода читается теми же фрагментами
 */

const CART_DATA_FOR_BASKET_QUERY = gql`
    query CART_DATA_BASKET_MENU(
        $period: String!
    ) {
        cart(
            period: $period
        ) {
            type
            period
            isSubscriptionActivated
            totals {
                total_discount_price
                total_price
                delivery_price
            }
            discount_conditions {
                promocode
                promocode_status
                isCertificate
                isPromoCodeActivated
                promoCodeApplyingErrorMessage
                isPromocodeCombineWithDiscount
                isPromocodeCombineWithAccount
                differenceBetweenPromocodeAndOrder
                promoCodeApplyingErrorMessage
                isPromoCodeExists
                isSubscriptionActivated
                deliveriesCount
                discountType
                discountValue
                discountDuration
            }
        }
    }
`;

const NewDishImage = (props) => {
    const { cacheRef, openDishDetails } = props;

    const [isLoadingError, setIsLoadingError] = useState(false);

    const { data: { dish } } = useFragment({
        fragment: NEW_DISH_CARD_IMG,
        from: {
            __ref: cacheRef,
        },
    });

    /* SELECTORS */
    const imgPath = useMemo(() => {
        if (isLoadingError) return stubSrc;
        if (dish?.verticalImage?.includes('stub-v')) return dish?.previewMobileImage;
        return dish?.verticalImage || dish?.previewMobileImage;
    }, [isLoadingError, dish?.previewMobileImage, dish?.verticalImage]);

    return (
        <img
            role="none"
            src={imgPath}
            alt={cacheRef}
            onError={() => setIsLoadingError(true)}
            styleName="new-dish-img-root"
            onClick={openDishDetails}
        />
    );
};

function measureText(pText, pStyle) {
    let lDiv = document.createElement('div');

    document.body.appendChild(lDiv);

    if (pStyle != null) {
        lDiv.style = pStyle;
    }
    lDiv.style.position = 'absolute';
    lDiv.style.left = -1000;
    lDiv.style.top = -1000;

    lDiv.textContent = pText;

    const lResult = {
        width: lDiv.clientWidth,
        height: lDiv.clientHeight,
    };

    document.body.removeChild(lDiv);
    lDiv = null;

    return lResult;
}

// eslint-disable-next-line arrow-body-style
const splitTitleOnToLines = (size) => (arr) => {
    return arr.reduce((acc, word) => {
        const { width } = measureText([...acc.firstLine, word].join(' '), 'fake-title');

        if (
            width <= size && !acc.isFirstLineCompleted
        ) {
            return {
                ...acc,
                firstLine: [...acc.firstLine, word],
            };
        }

        return {
            ...acc,
            secondLine: [...acc.secondLine, word],
            isFirstLineCompleted: true,
        };
    }, {
        firstLine: [],
        secondLine: [],
        isFirstLineCompleted: false,
    });
};

const defineMobileResolution = (width) => {
    if (width >= 375) {
        return 'l';
    }
    if (width >= 320 && width < 375) {
        return 'm';
    }
    return 's';
};

const ClampedTitle = (props) => {
    const {
        titleContainerCurrent,
        fullDishTitle,
    } = props;

    const [firstLineText, setFirstLineText] = useState('');
    const [secondLineText, setSecondLineText] = useState('');

    const clampWholeTitle = useCallback(
        () => {
            const refRect = titleContainerCurrent?.getBoundingClientRect();
            const paddings = {
                s: 10,
                m: 15,
                l: 20,
            };
            const resolution = defineMobileResolution(window.innerWidth);
            const padding = paddings[resolution];
            const {
                firstLine,
                secondLine,
                // eslint-disable-next-line no-unsafe-optional-chaining
            } = splitTitleOnToLines((refRect?.width - padding) || 0)(fullDishTitle.split(' '));
            const textOne = firstLine.join(' ');
            const textTwo = secondLine.join(' ');
            const excuseEndRegex = /\s([с|и|в|из|со|по])$/;

            if (excuseEndRegex.test(textOne)) {
                try {
                    // eslint-disable-next-line no-unused-vars
                    const [_, entry] = textOne.match(excuseEndRegex);
                    const s1 = textOne.replace(excuseEndRegex, '');
                    setFirstLineText(tp.execute(s1));
                    setSecondLineText(tp.execute(`${entry} ${textTwo}`));
                } catch {
                    setFirstLineText(tp.execute(textOne));
                    setSecondLineText(tp.execute(textTwo));
                }
            } else {
                setFirstLineText(tp.execute(textOne));
                setSecondLineText(tp.execute(textTwo));
            }
        },
        [fullDishTitle, titleContainerCurrent],
    );


    useEffect(
        () => {
            clampWholeTitle();
            window.addEventListener('resize', clampWholeTitle);
            return () => {
                window.removeEventListener('resize', clampWholeTitle);
            };
        },
        [clampWholeTitle],
    );

    return (
        <div styleName="dish-title-root">
            <div styleName="dish-title-first-line">
                {firstLineText}
            </div>
            <div styleName="dish-title-second-line">
                {secondLineText}
            </div>
        </div>
    );
};

const NewDishRightSideComponent = (props) => {
    const {
        openPortionSelectDatail,
        cacheRef,
        openDishDetails,
        selectedDishId,
        setSelectedDishId,
        isCustomizationEnabled,
        mutateItemInCart,
        isCartUpdating,
        dishId,
        categoryId,
        period: periodOverride = null,
        canModifyDish = true,
    } = props;

    const titleContainerRef = useRef(null);
    const [titleContainerCurrent, setTitleContainerCurrent] = useState(null);
    const selectedPeriod = useReactiveVar(selectedPeriodVar);
    const period = periodOverride || selectedPeriod;
    const { onOpenSelection } = useContext(DishesSelectionContext);

    useEffect(() => {
        setTitleContainerCurrent(titleContainerRef.current);
    }, [titleContainerRef]);

    const { ingredientsList, isDishCustomized } = useDishCustoms(selectedDishId || '');

    const replacebleIngredients = useMemo(
        () => {
            const ingredients = ingredientsList
                .map((item) => item?.replaceableIngredient);
            return ingredients.filter((item) => Boolean(item));
        },
        [ingredientsList],
    );

    const isCustomSelect = useMemo(
        () => canModifyDish
            && isDishCustomized && !isCustomizationEnabled && replacebleIngredients.length > 1,
        [canModifyDish, isDishCustomized, isCustomizationEnabled, replacebleIngredients]);

    /* DAC */
    useQuery(FETCH_JSON_CUSTOMIZATION_COMMENT, {
        context: {
            message: 'bakset:support:NewDishRightSideComponent',
        },
    });

    const {
        data: {
            portions, price, dish, promoDiscountPrice,
            discount_price, dish_id, has_crossed_out_price, is_promo,
        },
    } = useFragment({
        fragment: NEW_DISH_CARD_FRAGMENT,
        from: {
            __ref: cacheRef,
        },
    });

    const currentDiscountPrice = (dish_id === '3503' && isDateInRange(period, '2026-05-11', 1))
        ? 0
        : promoDiscountPrice;

    /* @note результат запроса нужен только ради кэша: DiscountConditions
     * пишется под id DiscountConditions:<текущий период>, поэтому для карточки
     * чужого цикла он затёр бы условия основной корзины, а читался бы всё
     * равно другой id (ниже) — для доп. цикла запрос не выполняем */
    const data = useQuery(CART_DATA_FOR_BASKET_QUERY, {
        variables: {
            period,
        },
        skip: period !== selectedPeriod,
    });

    const {
        data: {
            isSubscriptionActivated, isPromoCodeActivated, discountType,
        },
    } = useFragment({
        fragment: RECCURENT_CART_DATA,
        from: {
            __ref: `DiscountConditions:${period}`,
        },
    });


    const isDishWithCrossedPrice = (isPromoCodeActivated
        && discountType === CROSSED_PRICE_DISCOUNT_TYPE
        && dish?.category_id === Number(CATEGORY_MAIN))
        || has_crossed_out_price
        || (dish_id === '3503' && isDateInRange(period, '2026-05-11', 1));

    /* SELECTORS */
    const fullDishTitle = `${dish?.title} ${dish?.caption}`;

    const isNYDish = useMemo(
        () => dish?.tags?.some((tag) => tag.id === NY_DISHES),
        [dish],
    );

    const currentPrice = useMemo(
        () => (isSubscriptionActivated && !isNYDish ? (discount_price / portions) : (price / portions)),
        [portions, price, discount_price, isSubscriptionActivated, isNYDish],
    );

    const isSwapDishButtonShown = useMemo(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const hideParams = urlParams.get('dish_swap') || '';
        const param = hideParams || '';
        return param?.includes('1');
    }, []);

    /* STYLES */

    const contentRoot = cn({
        'new-dish-content-root': true,
    });

    const newDishControls = cn({
        'new-dish-controls-root': true,
    });

    const newDishContolsButtons = cn({
        'dish-controls-main-buttons-wrapper': true,
        without_customization: !isCustomSelect && isSwapDishButtonShown,
    });

    const onNextIdSelected = (nextDishId) => {
        setSelectedDishId(nextDishId);
    };

    const openCategorySelection = () => {
        onOpenSelection({ tag: categoryId, targetRealm: 'new_upsell' });
        URLUpdater({ dish_to_replace: dishId });
        analyticService.push({
            eventName: 'Change_dish_Basket',
            dish_id: dishId,
            dish_name: dish.title,
        });
    };


    const { segment } = useContext(PathSegmentContext);

    const onSubmitHandler = ({ onCompoleted }) => {
        try {
            if (selectedDishId === dish_id) {
                onCompoleted();
            } else {
                mutateItemInCart({
                    onCompoleted,
                    dishes: [
                        {
                            dish_id: selectedDishId,
                            portions,
                        },
                        {
                            dish_id,
                            portions: 0,
                        },
                    ],
                    optimistic: segment === 'delivery' ? null : 'swipe',
                });
            }
        } catch (err) {
            console.err(err);
        }
    };

    return (
        <div styleName={contentRoot}>
            <div styleName={newDishControls}>
                <div styleName={newDishContolsButtons}>
                    <button
                        onClick={openDishDetails}
                        styleName="dish-control-title"
                        type="button"
                        ref={titleContainerRef}
                        id="dish-control-title-wrapper"
                    >
                        <ClampedTitle
                            titleContainerCurrent={titleContainerCurrent}
                            fullDishTitle={fullDishTitle}
                        />
                    </button>
                    <button
                        styleName="dish-control-portion-button-wrapper"
                        onClick={() => {
                            if (!has_crossed_out_price) {
                                openPortionSelectDatail();
                            }
                        }}
                        disabled={isCustomizationEnabled || isCartUpdating}
                    >
                        <div styleName="dish-control-portion basket-with--dots">
                            <div styleName="dish-control-protion__count">
                                {portions}
                            </div>
                            <div styleName="dish-control-protion__divider">
                                x
                            </div>
                            <div styleName="dish-control-protion__price">
                                {isDishWithCrossedPrice ? (currentDiscountPrice / portions) : currentPrice}
                                <span
                                    style={{ paddingLeft: 2, fontWeight: 500 }}
                                    styleName="rubCharWrapper"
                                >
                                    <Rub />
                                </span>
                            </div>

                        </div>
                        {isDishWithCrossedPrice && (
                            <div styleName="dish-control-crossed-price">
                                {`${portions} х ${currentPrice}`}
                                <span
                                    style={{ paddingLeft: 2, fontWeight: 500 }}
                                    styleName="rubCharWrapper"
                                >
                                    <Rub />
                                </span>
                                <div styleName="dish-control-crossed-price__line" />
                            </div>
                        )}
                    </button>
                </div>
                {canModifyDish && isSwapDishButtonShown && (
                    <button
                        styleName="dish-control-replace-button-wrapper"
                        onClick={openCategorySelection}
                    >
                        <div styleName="dish-control-replace">
                            Заменить блюдо
                        </div>
                    </button>
                )}
                {isCustomSelect && (
                    <div styleName="dish-control-select-wrapper">
                        <CustomIngredientsSelectDishRow
                            environmentContext="basket"
                            selectedDishId={selectedDishId}
                            onNextIdSelected={onNextIdSelected}
                            id={selectedDishId}
                            optionsList={ingredientsList}
                            disabled={isCartUpdating || isCustomizationEnabled}
                            onSubmitHandler={onSubmitHandler}
                            titleRenderField="replaceableIngredient"
                        />

                    </div>
                )}
            </div>
        </div>
    );
};

export const NewDishCard = (props) => {
    const {
        uiState,
        handleChangePortion,
        handleRemoveDish,
        onClickMobilePortions,
        cacheRef,
        openDishDetails,
        mutateItemInCart,
        isCartUpdating,
        isEditBasketBlock,
        basketDishObserver = null,
        period: periodOverride = null,
        canModifyDish = true,
    } = props;

    const [isPortionOpen, setIsPortionOpen] = useState(false);
    const [transition, setTransition] = useState('default');
    const dishRef = useRef(null);
    const {
        data: {
            dish_id, dish, portions: portion, has_crossed_out_price,
        },
    } = useFragment({
        fragment: NEW_DISH_CARD_FRAGMENT,
        from: {
            __ref: cacheRef,
        },
    });

    const [selectedDishId, setSelectedDishId] = useState(dish_id);

    const isRomanticDish = useMemo(
        () => romanticDishes.includes(dish_id),
        [dish_id],
    );

    const isRomanticEditDisabled = sessionStorage.getItem('is_romantic_edit_disabled') && isRomanticDish;

    const changePortionCount = ({ value }) => {
        const eventName = value < portion ? 'Custom_Card_Dish_decrease_quantity' : 'Custom_Card_Dish_increase_quantity';
        analyticService.push({
            eventName,
            source_name: 'basket',
            dish_id,
            value: String(value),
        });

        handleChangePortion({ id: dish_id, value });
    };

    const handleOpenDetails = useCallback(() => {
        openDishDetails(dish_id);
    }, [openDishDetails, dish_id]);

    const openPortionSelectDatail = () => {
        if (dish_id === '5336') return;
        if (isDesktop()) {
            setIsPortionOpen(true);
        } else {
            onClickMobilePortions({
                id: dish_id,
                portions: dish.portions,
                portion,
                weight: dish.weight,
                onChange: changePortionCount,
                portionAlias: null,
            });
        }
    };

    const removeDishUIHandler = () => {
        setTransition('exiting');
        handleRemoveDish(dish_id);

        const localStorageKeys = Object.keys({ ...localStorage });
        localStorageKeys
            .filter((key) => key.includes(dish_id))
            .forEach((key) => localStorage.removeItem(key));

        const additionalDishAdded = sessionStorage.getItem('additionalDishAdded');
        analyticService.push({
            eventName: 'Custom_Card_Dish_Delete',
            dish_id,
            source: dish_id === '5040' && additionalDishAdded
                ? 'upsell_check_mark'
                : 'basket',
        });
    };

    const executeScrollAfterTopDishCartMutations = useCallback(
        (topDishId, direction) => {
            const basketSrollableContainerL = document.querySelector('#basketAreasListDesktop');
            const basketSrollableContainerS = document.getElementById('basket-frame-root');
            const currentNode = isDesktop()
                ? basketSrollableContainerL
                : basketSrollableContainerS;

            const scrollValue = (!isDesktop() && isIOS()) ? 87 : 174;
            if (dish_id !== topDishId) return;

            currentNode?.scrollBy(
                0,
                direction === 'up' ? scrollValue : -scrollValue,
            );
        },
        [dish_id],
    );

    useEffect(
        () => {
            if (dishRef.current && basketDishObserver) {
                basketDishObserver.observe(dishRef.current);
            }
        },
        [basketDishObserver],
    );

    useEffect(
        () => {
            executeScrollAfterTopDishCartMutations('25', 'up');
            return () => {
                executeScrollAfterTopDishCartMutations('25', 'down');
            };
        },
        [executeScrollAfterTopDishCartMutations],
    );

    const dishCardAnimationWrapper = cn({
        'new-dish-animation-wrapper': true,
        [transition]: true,
    });

    const dishCardRoot = cn({
        'new-dish-card-root': true,
    });

    const dishCardImageRow = cn({
        'new-dish-card-image-row': true,
    });

    const dishCardRightRow = cn({
        'new-dish-card-left-row': true,
    });

    const isCustomizationEnabled = isEditBasketBlock;

    return (
        <>
            <div
                styleName={dishCardAnimationWrapper}
                data-id={dish_id}
                ref={dishRef}
            >
                <div styleName={dishCardRoot}>
                    {(!isEditBasketBlock && !isRomanticEditDisabled && !has_crossed_out_price) && (
                        <button
                            disabled={isCartUpdating}
                            styleName="new-dish-card-delete-btn"
                            onClick={removeDishUIHandler}
                        >
                            <img
                                src={deleteIcon}
                                alt="d-icon"
                            />
                        </button>
                    )}
                    <div styleName={dishCardImageRow}>
                        <NewDishImage
                            cacheRef={cacheRef}
                            openDishDetails={handleOpenDetails}
                        />
                    </div>
                    <div styleName={dishCardRightRow}>
                        <NewDishRightSideComponent
                            dishId={dish_id}
                            categoryId={dish?.category_id}
                            uiState={uiState}
                            openPortionSelectDatail={openPortionSelectDatail}
                            cacheRef={cacheRef}
                            openDishDetails={handleOpenDetails}
                            selectedDishId={selectedDishId}
                            setSelectedDishId={setSelectedDishId}
                            isCustomizationEnabled={isCustomizationEnabled}
                            mutateItemInCart={mutateItemInCart}
                            isCartUpdating={isCartUpdating}
                            isEditBasketBlock={isEditBasketBlock}
                            period={periodOverride}
                            canModifyDish={canModifyDish}
                        />
                    </div>
                </div>
            </div>
            <BasketPortionSelect
                isPortionOpen={isPortionOpen}
                onReject={() => setIsPortionOpen(false)}
                dish_id={dish_id}
                changePortionCount={changePortionCount}
            />
        </>
    );
};
